import { render, staticRenderFns } from "./MonitorarPratica.vue?vue&type=template&id=3f4e45a1"
import script from "./MonitorarPratica.vue?vue&type=script&lang=js"
export * from "./MonitorarPratica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports